var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import translations from "../../translations/resources/en-GB.json";
import VenuesList from "../../features/venuesList/VenuesList";
import DropDown from "../../components/dropDown/DropDown";
import "./listView.scss";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { HDSButton } from "@here/hds-react-components/Button";
import SearchBox from "../../components/searchBox/SearchBox";
import { setIsSortClicked } from "../../store/reducers/venuesSlice";
import { MapKeys, MAP_STATUS, PORTAL_TABS } from "../../store/common/constants";
import { ConfigService } from "../../services/configservice";
var ListView = function (_a) {
    var venueState = _a.venueList, onSearchChange = _a.onSearchChange, onSortChange = _a.onSortChange, searchText = _a.searchText, sortText = _a.sortText, onFilterChange = _a.onFilterChange, disableFilter = _a.disableFilter, setIsVenueListUpdated = _a.setIsVenueListUpdated;
    var dispatch = useDispatch();
    var selectedTab = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.selectedTab; });
    var _b = useState(false), isDropdownOpen = _b[0], setIsDropdownOpen = _b[1];
    var enableStatusFilter = ConfigService.features.showDraftStatusFilter &&
        selectedTab === PORTAL_TABS.INTERNAL_TOOLS;
    var listDrop = [
        translations.data["venonboard.listView.dropDown.listItem1"],
        translations.data["venonboard.listView.dropDown.listItem2"],
    ];
    var filterDrop = [
        translations.data["venonboard.listView.filter.showAll"],
        MAP_STATUS[MapKeys.CHECKED_IN].LABEL,
        MAP_STATUS[MapKeys.CHECKED_OUT].LABEL,
    ];
    var valuesList = {
        modified: translations.data["venonboard.listView.dropDown.listItem1"],
        name: translations.data["venonboard.listView.dropDown.listItem2"],
    };
    var filterList = {
        all: translations.data["venonboard.listView.filter.showAll"],
        checkin: MAP_STATUS[MapKeys.CHECKED_IN].LABEL,
        checkout: MAP_STATUS[MapKeys.CHECKED_OUT].LABEL,
    };
    var sortByParams = {
        "Last updated": "modified",
        Name: "name",
    };
    var sortList = function (sortByMap) {
        var sortBy = sortByParams[sortByMap];
        dispatch(setIsSortClicked(true));
        onSortChange(sortBy);
        setIsDropdownOpen(false);
    };
    var handleVenueListUpdated = function (value) {
        setIsVenueListUpdated && setIsVenueListUpdated(value);
    };
    var styleAttentionIcon = {
        "--hds-icon-color": "var(--hds-foreground-inactive)",
        paddingBottom: "14px",
    };
    var defaultFilterValue = filterList[sortText]
        ? filterList[sortText]
        : filterList.all;
    var countDisplay = selectedTab !== "overview" ? (_jsxs("div", __assign({ className: "listCounterWrapper" }, { children: [_jsxs("div", __assign({ className: "listCounter" }, { children: [venueState === null || venueState === void 0 ? void 0 : venueState.length, " ", "results"] })), _jsxs("div", __assign({ className: "listSort" }, { children: [selectedTab === PORTAL_TABS.INTERNAL_TOOLS && (_jsx(SearchBox, { onChange: function (s) {
                            onSearchChange(s);
                        }, searchText: searchText })), _jsx("div", __assign({ style: {
                            pointerEvents: (venueState === null || venueState === void 0 ? void 0 : venueState.length) === 0 ? "none" : "auto",
                        } }, { children: _jsx(DropDown, { itemList: listDrop, menuWidth: "150px", displayListItemIcon: true, onChange: sortList, value: valuesList[sortText] ? valuesList[sortText] : "", "data-cy": "sort-dropdown", id: "sort-dropdown", trigger: _jsx("div", __assign({ className: "sortDropdownTriggerContainer" }, { children: _jsx(HDSButton, __assign({ onClick: function () { return setIsDropdownOpen(function (prev) { return !prev; }); }, variant: "subtle", size: "large", width: "160px", "icon-right": "".concat(isDropdownOpen ? "chevron-up" : "chevron-down"), className: "".concat(isDropdownOpen ? "chevron-up" : "chevron-down") }, { children: _jsx("div", __assign({ className: "sortDropdownLabel" }, { children: valuesList[sortText] })) })) })) }) })), enableStatusFilter && (_jsx("div", __assign({ className: "filter" }, { children: _jsx(DropDown, { trigger: _jsx(HDSButton, { variant: "secondary", size: "medium", icon: "filter-on", iconCategory: "discovery-sharing", iconOnly: true, disabled: disableFilter }), menuWidth: "100", itemList: filterDrop, displayListItemIcon: true, onChange: onFilterChange, value: defaultFilterValue, "data-cy": "filter-check-In/out", id: "filter-checkIn-In/out", itemCheckMarkSize: "small" }) })))] }))] }))) : (_jsx("div", __assign({ className: "mapCaption" }, { children: "Your indoor maps" })));
    return (_jsxs(_Fragment, { children: [countDisplay, (venueState === null || venueState === void 0 ? void 0 : venueState.length) > 0 ? (_jsx(_Fragment, { children: _jsx(VenuesList, { data: venueState, handleVenueListUpdated: handleVenueListUpdated }) })) : (_jsx("div", { children: _jsxs("div", __assign({ className: "noIndoorMapContainer" }, { children: [_jsx(HDSIcon, { name: "attention", "icon-style": "outline", size: "24px", style: styleAttentionIcon }), _jsx("div", __assign({ className: "noMapIndoorCaption" }, { children: translations.data["venonboard.listView.noIndoorMapCaption"] }))] })) }))] }));
};
export default ListView;
